/* Advance-only containment until same-day checkout enforcement is validated.
 * Preserve Giftship's advance-date rules, blackouts and maximum date.
 * Theme guards cannot invalidate previously created or direct checkouts.
 */
(function () {
  'use strict';
  var states = new WeakMap();
  function dayNumber(date) {
    return Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());
  }
  function today(now) {
    // The shop is in Brampton. IANA time handles DST and customers abroad.
    var parts = new Intl.DateTimeFormat('en-CA', {
      timeZone: 'America/Toronto', year: 'numeric', month: 'numeric', day: 'numeric'
    }).formatToParts(now || new Date());
    var fields = {};
    parts.forEach(function (part) {fields[part.type] = part.value;});
    return new Date(Number(fields.year), Number(fields.month) - 1, Number(fields.day));
  }
  function isToday(date) {return !!date && dayNumber(date) === dayNumber(today());}
  function holidaySunday(date) {
    var month = date.getMonth() + 1, day = date.getDate();
    return (month === 2 && day === 14) || (month === 12 && day === 25) || (month === 5 && day >= 8 && day <= 14);
  }
  function correctedMinimum(rules, now) {
    // This containment supports the reviewed shop-time profile. Unknown modes
    // fail closed instead of guessing at vendor lead-day arithmetic.
    if (rules.cutoff_time_type !== 'shop_time' || rules.add_disallowed_to_lead !== false ||
        !/^[0-9]+$/.test(String(rules.lead_time)) || Number(rules.lead_time) > 36600 ||
        !Array.isArray(rules.disallowed_days)) throw new Error('Unreviewed advance-date rules');
    var match = /^(\d{1,2}):(\d{2})(?::(\d{2}))?$/.exec(rules.cutoff_time || '');
    if (!match || Number(match[1]) > 24 || Number(match[2]) > 59 || Number(match[3] || 0) > 59 ||
        (Number(match[1]) === 24 && (Number(match[2]) !== 0 || Number(match[3] || 0) !== 0))) throw new Error('Invalid advance cutoff');
    var parts = new Intl.DateTimeFormat('en-CA', {timeZone: 'America/Toronto', hourCycle: 'h23', hour: '2-digit', minute: '2-digit', second: '2-digit'}).formatToParts(now);
    var fields = {};
    parts.forEach(function (part) {fields[part.type] = part.value;});
    var seconds = Number(fields.hour) * 3600 + Number(fields.minute) * 60 + Number(fields.second);
    var cutoff = Number(match[1]) * 3600 + Number(match[2]) * 60 + Number(match[3] || 0);
    var date = today(now);
    date.setDate(date.getDate() + Number(rules.lead_time) + (seconds >= cutoff ? 1 : 0));
    return date;
  }
  function apply(fp, pickup, rules) {
    if (!rules || !window.Gs || !Gs.datepicker || !Gs.datepicker.actions) throw new Error('Date rules are unavailable');
    var state = states.get(fp);
    if (!state) {
      state = {baseDisable: (fp.config.disable || []).slice()};
      states.set(fp, state);
      state.disable = function (date) {
        var day = dayNumber(date);
        if (state.blocked.indexOf(day) !== -1) return true;
        if (date.getDay() === 0 && !holidaySunday(date)) return true;
        return day < state.minimum;
      };
    }
    var now = new Date(), shopToday = today(now);
    var corrected = correctedMinimum(rules, now);
    var minimum = fp.parseDate(Gs.datepicker.actions.getLeadTime(rules), 'Y-m-d');
    if (!minimum || !Number.isFinite(minimum.getTime())) throw new Error('Advance date rules are unavailable');
    state.today = dayNumber(shopToday);
    // Never relax a later vendor minimum; only close the verified timezone gap.
    state.minimum = Math.max(state.today + 86400000, dayNumber(minimum), dayNumber(corrected));
    state.pickup = !!pickup;
    // Giftship styles explicit blackouts in onDayCreate. Also enforce them here
    // so programmatic selection/checkout checks cannot skip a disabled day.
    state.blocked = (rules.disabled_dates || []).map(function (value) {
      var iso = window.GIST && GIST.datetime && GIST.datetime.toISODate ? GIST.datetime.toISODate(value) : value;
      var parsed = fp.parseDate(iso, 'Y-m-d');
      if (!parsed || !Number.isFinite(parsed.getTime())) throw new Error('A blocked date could not be read');
      return dayNumber(parsed);
    });
    var signature = JSON.stringify([state.today, state.minimum, state.pickup, state.blocked]);
    if (signature !== state.signature) {
      state.signature = signature;
      fp.set('disable', state.baseDisable.concat([state.disable]));
      fp.set('minDate', shopToday);
      fp.redraw();
    }
    if (fp.selectedDates.length && !fp.isEnabled(fp.selectedDates[0])) fp.clear(true);
  }
  window.ffgDeliveryDates = {apply: apply, today: today, isToday: isToday};
}());
